import { buildCommonComponent, kindQuery } from '@zapier/legacy-components';
import './FlexGroup.scss';

const buildFlexRowGroupComponent = buildCommonComponent('flex-group');
export const FlexGroup = kindQuery(buildFlexRowGroupComponent());
export const FlexGroupCell = kindQuery(buildFlexRowGroupComponent('__cell'));
export default FlexGroup;
